// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sumar-zmluva-card {\n  border: 1px white solid !important;\n}\n.sumar-predmet-check-icon {\n  color: #0097FD !important;\n}\n.debug-card {\n  position: fixed !important;\n  top: 150px;\n  left: 0;\n  overflow: scroll;\n  z-index: 1;\n}\n.debug-card:hover {\n  z-index: 5;\n}\n.debug-card th {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
